import { ref, getCurrentInstance, computed } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import { ACTIONS, PRIVATE } from '@/plugins/acl/const'

export default function useOccupancyHardDelete({ onSuccess } = {}) {
  const vm = getCurrentInstance().proxy
  const canHardDelete = computed(() => vm.$can(ACTIONS.DELETE, PRIVATE.STAFF.OCCUPANCY_HARD_DELETE))

  const { deleteOccupant, deleteCustomAddress } = useActions('staff', [
    'deleteOccupant',
    'deleteCustomAddress',
  ])

  const isHardDeleteDialogVisible = ref(false)
  const hardDeleteLoading = ref(false)
  const itemToHardDelete = ref(null)

  const askHardDelete = (item) => {
    itemToHardDelete.value = item
    isHardDeleteDialogVisible.value = true
  }

  const discardHardDelete = () => {
    itemToHardDelete.value = null
    isHardDeleteDialogVisible.value = false
  }

  const confirmHardDelete = async () => {
    if (!itemToHardDelete.value) return
    hardDeleteLoading.value = true

    const item = itemToHardDelete.value
    const { success } = item.type === 'custom'
      ? await deleteCustomAddress(item.id)
      : await deleteOccupant({ occupantId: item.id })

    if (success) {
      if (onSuccess) await onSuccess()
      itemToHardDelete.value = null
      isHardDeleteDialogVisible.value = false
    }
    hardDeleteLoading.value = false
  }

  return {
    canHardDelete,
    isHardDeleteDialogVisible,
    hardDeleteLoading,
    itemToHardDelete,
    askHardDelete,
    discardHardDelete,
    confirmHardDelete,
  }
}
